import Vue from 'vue'
import App from './App.vue'
import Cookies from 'js-cookie'
import * as echarts from 'echarts'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/account.scss'
import './assets/css/main.scss'
import '@/assets/file/index'
// 全局组件
import Navbar from './components/common/Navbar.vue'
import Header from './components/common/Header.vue'
import Folder from './components/common/folder.vue'
import breadcrumbpage from './components/common/breadcrumbpage.vue'
import Pagination from './components/element/Pagination.vue'
import btnupload from './components/common/uploadBtn.vue'
import Draggable from 'vuedraggable'
import router from './router'
import store from './store'
import './permission'
import { download } from '@/api/request'
Vue.prototype.download = download
Vue.component('Navbar', Navbar)
Vue.component('Header', Header)
Vue.component('Folder', Folder)
Vue.component('breadcrumbpage', breadcrumbpage)
Vue.component('Draggable', Draggable)
Vue.component('Pagination', Pagination)
Vue.component('btnupload', btnupload)
Vue.config.productionTip = false
Vue.use(Element, {
  size: Cookies.get('size') || 'medium',
})
Vue.prototype.$echarts = echarts
Vue.use(echarts)

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount('#app')
